// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"CompletedTable_pageTitle__2k8fo","tableSection":"CompletedTable_tableSection__t6zg4","action":"CompletedTable_action__QG94h"};